import { all, fork } from "redux-saga/effects";
//layout

import AuthSaga from "./auth/login/saga";

import LayoutSaga from "./layouts/saga";


// Pages > Team
import teamSaga from "./team/saga";


//Jobs
import ApplicationSaga from "./job/saga";

export default function* rootSaga() {
  yield all([
    //public

    fork(AuthSaga),

    fork(teamSaga),
    fork(LayoutSaga),

    fork(ApplicationSaga),

  ]);
}
